const {
  keysSortedByValueAscending
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * Returns options corresponding to asset parts.
  *
  * @function evalute - evaluate ucbAssetPartsOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = source2 => evaluateSource(source2, content, parentContentPath, transientContext, nativeFunctions);
  const partsSource = {
    type: 'readReferencedContentBehavior',
    contentPath: 'asset/?/parts'
  };
  const parts = (await sourceEvaluator(partsSource)) || {};
  const options = {};
  const keys = keysSortedByValueAscending(parts);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const {
      identifier
    } = parts[key];
    if (identifier !== undefined) {
      options[key] = {
        title: identifier,
        _created: i + 1
      };
    }
  }
  return options;
};
module.exports = {
  evaluate
};